
import axios from "axios";
import {toStringWithToDigits} from "@k/js/user";
import {LogoPoolStoreStatic} from "@k/js/logopoolInteractor";
import {sendPostRequest} from "@k/global/axiosFormWrapper";
import {LogoPoolEntry} from "@k/js/databaseInterfaceClasses";
import {EventVerteiler} from "@k/global/eventVerteiler";


function addPathToPreviewProperty(e: { pathToPreview? }) {
    e.pathToPreview = "";
    return e;
}

function ensureFilenameoriginal(e) {
    if(typeof(e.filenameOriginal) === "undefined") {
        e.filenameOriginal = null;
    }
    return e;
}

function ensureAddedDate(e) {
    if(typeof(e.addedDate) === "undefined") {
        const date = new Date();
        e.addedDate = [date.getFullYear(),toStringWithToDigits(date.getMonth()+1), toStringWithToDigits(date.getDay())].join("-")
    }
    return e;
}

export default {
    state: () => ({
        logoPool: []
    }),
    getters: {
        getLogoPool:(state)=>state.logoPool,
        getLogoPoolEntryByTypeAndID: (state) => (type, id)=>{
            return state.logoPool.find(e=>e.type === type && e.id === id) ||
                state.logoPool.find(l=>l.type === type && l.objectstorage_key_prefix+"_"+l.id+".png") ||
                null;
        },
        getLogoPoolEntryByID : (state)=>(id)=>{
            return state.logoPool.find(e => e.id === id) || null
        },
        getLogoByFilename : state=>(filename)=>state.logoPool.find(e=>e.filename === filename) || null
    },
    mutations: {
        SETLOGOPOOL: (state, logos:LogoPoolEntry[]) => {
            const newLogos = logos.filter(l=>!state.logoPool.some(l2=>l2.id === l.id));
            const deletedLogos = state.logoPool.filter(l=>!logos.some(l2=>l2.id === l.id));
            state.logoPool = state.logoPool.concat(newLogos);
            deletedLogos.forEach(l=>state.logoPool.splice(LogoPoolStoreStatic.getLogoPoolIndexByTypeAndID(l.type, l.id, state.logoPool),1));
        },
        ADD_LOGOS : (state, newLogos)=>{
            const toAdd = newLogos.map(addPathToPreviewProperty).map(ensureFilenameoriginal).map(ensureAddedDate);
            for(let i=0; i < toAdd.length; i++) {
                state.logoPool.push(toAdd[i]);
            }
        },
        DELETE_LOGOS : (state, logoPoolEntriesToDelete)=>{
            logoPoolEntriesToDelete.forEach(l=>state.logoPool.splice(LogoPoolStoreStatic.getLogoPoolIndexByTypeAndID(l.type, l.id, state.logoPool),1))
        }
    },
    actions: {
        loadLogoPool(context, username) {
            axios({
                method: "get",
                url: "/konfigurator_php/designmodul/logos.php?username="+username,
                headers: {'content-type': 'application/x-www-form-urlencoded'},
            }).then((response) => {
                context.commit("SETLOGOPOOL", response.data);
                EventVerteiler.broadcast("logoPoolLoaded");
            })
        },
        deleteLogoFromLogoPool(context, logoPoolEntry:LogoPoolEntry) {
            sendPostRequest("/konfigurator_php/actionmodul/deleteLogo.php", {id:logoPoolEntry.id}).then(response=>{
                if (parseInt(response.data) === 1) {
                    context.commit("DELETE_LOGOS", [logoPoolEntry]);
                } else {
                    console.warn("ajaxFail", "deleteLogo", "could not delete Logo");
                }
            })
        }
    }
}
